module.exports.PageController = require('./PageController')
module.exports.HomepageController = require('./HomepageController')
module.exports.NotFoundController = require('./NotFoundController')
module.exports.LooksController = require('./LooksController')
